import api from '@whitelabel/xcover-shared/helpers/api';
import { MESSAGE_SLUGS } from '@whitelabel/xcover-shared/helpers/constants';
import { retry } from './utils';

export const loadMessages = (locale: string, requestInit?: RequestInit): any =>
  retry(() =>
    api.get(
      `${process.env.REACT_APP_MESSAGES_HOST}/messages/frontend/${MESSAGE_SLUGS.FE_MESSAGES_SLUG}?language=${locale}`,
      false,
      requestInit || {},
    ),
  );
